export default {
	// 列表配置
	// 菜单列表
	menu: [
		{
			title: '订单管理',            // 一级菜单名称
			icon: 'el-icon-location',   // 一级菜单 icon
			menuId: '01',                // 索引(必须唯一，是字符串)
			qx:'gys,cgy',
			sub: [                      // 子菜单(二级菜单)
				{
					title: '采购订单',      // 菜单名称
					component: 'pursh',    // 点击菜单打开的组件名称
					menuId: '0101',// 索引 (用于识别当前打开的tab,必须唯一，是字符串)
					qx:'gys'
				},
				// {title: '采购订单明细查询', component: 'report', menuId: 'GYS_PURPR',qx:'gys,cgy'},
			]
		},
		{
			title: '到货管理',
			icon: 'el-icon-menu',
			menuId: '05',
			qx:'gys,cgy',
			sub: [
				{title: '到货计划', component: 'transform', menuId: '0500',qx:'gys,cgy'},
			]
		},
		{
			title: '发运管理',
			icon: 'el-icon-menu',
			menuId: '02',
			qx:'gys,cgy',
			sub: [
				{title: '送货单', component: 'asn', menuId: '0200',qx:'gys'},//送货单 ASN发运计划
				// {title: '送货单查询', component: 'report', menuId: 'GYS_ANSList',qx:'gys,cgy'},
			]
		},
		{
			title: '报表管理',
			icon: 'el-icon-document',
			menuId: '03',
			qx:'gys,cgy',
			sub: [
				// {title: '对账单', component: 'report', menuId: 'GYS_DZ',qx:'gys,cgy'},
			]
		},
		{
			title: '系统管理',
			icon: 'el-icon-setting',
			menuId: '04',
			qx:'gys',
			sub: [
				{title: '密码修改', component: 'passset', menuId: '0403',qx:'gys'},
			]
		}
	],
	// 收藏列表  字段说明同 [菜单列表]
	favor: [
		{title: '子菜单1-1', component: 'hello1', menuId: '1-1'},
		{title: '子菜单1-2', component: 'hello2', menuId: '1-2'},
		{title: '子菜单1-3', component: 'hello3', menuId: '1-3'},
		{title: '子菜单2-1', component: 'hello1', menuId: '2-1'},
		{title: '子菜单2-2', component: 'hello2', menuId: '2-2'},
		{title: '子菜单2-3', component: 'hello3', menuId: '2-3'}
	],
	// 应用列表
	application: [
		{
			title: '应用1：组件管理',
			divided: false,
			url: '/',
		},
		{
			title: '应用2：注册证管理',
			divided: false,
			url: '/',
		},
		{
			title: '应用3：产品管理',
			divided: false,
			url: '/',
		},
		{
			title: '返回应用中心',        // 显示名称
			divided: true,              // 分割线
			url: 'http://www.baidu.com', // 跳转地址
			icon: 'el-icon-arrow-left'  // 图标（可选）
		}
	],
	// 主页 tab 配置
	homeTab: {
		title: '首页',                     //  tab 显示标题
		menuId: 'home',                   //  tab 内部名称(用来识别当前打开的tab)
		components: [{path: 'home'}],     //  tab 对应的组件
	}
}
